window.ActivityStreamForm = (function() {

    "use strict";

    var time_delay;
    var $activity_container;
    var more_data = true;
    var current_page = 0;
    var $scroll_container = $(window);
    var store = {};

    var spinnerTemplate = '<div class="text-center m-15 js-loading-icon"><span class="fa-stack fa-2x text-inverse">\
                                <i class="fa fa-circle fa-2x fa-stack-2x"></i>\
                                <i class="fa fa-spinner fa-pulse fa-inverse"></i>\
                            </span></div>';

    function infiniteScrollDiv() {
        if (more_data) {
            if ($scroll_container.data('ajaxready') == false) return;
            if (($scroll_container.scrollTop() + $scroll_container.innerHeight()) >= ($scroll_container[0].scrollHeight - 1)) {
                $scroll_container.data('ajaxready', false);
                loadPage(current_page);
            }
        } else {
            $scroll_container.off('scroll');
            $('.js-loading-icon').remove();
        }
    }

    function getActivityStream(callback) {
        $.ajax({
            url: '/activity/stream',
            type: 'GET',
            data: $('.js-filter-form').serialize() + '&page=' + current_page,
            global: false,
            success: function(response) {
                store = response;
                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    }

    function loadUpdatedActivityCounts() {
        $.ajax({
            url: '/activity/get-updated-counts',
            type: 'GET',
            data: $('.js-filter-form').serialize(),
            global: false,
            success: function(response) {
                if(typeof response === 'object' && Object.keys(response).length !== 0) {
                    const types = response.types;
                    const typeCounts = response.type_counts;

                    for (let [typeKey, value] of Object.entries(types)) {
                        let count = 0;

                        if (typeKey in typeCounts) {
                            count = typeCounts[typeKey];
                        }

                        $("#note-type-" + typeKey).html(count);
                    }
                }
            }
        });
    }

    function loadPage(page) {
        setCurrentPage(page);
        $activity_container.append(spinnerTemplate);

        getActivityStream(function() {
            shouldLoadMore();
            removeSpinner();
        });

        return false;
    }

    function setCurrentPage(page) {
        if (page >= 0) {
            current_page = page;
        }
    }

    function removeSpinner() {
        $('.js-loading-icon').remove();
        $scroll_container.data('ajaxready', true);
    }

    function shouldLoadMore() {
        var isEmpty = store.trim() == "";
        appendOrReplace(isEmpty);
    }

    function appendOrReplace(isEmpty) {
        if (isEmpty && current_page == 0) {
            handleEmptyResponse();
            $activity_container.empty();

            // console.log('no results');

        } else if (isEmpty) {
            handleEmptyResponse();

            // console.log('empty response');

        } else if (current_page == 0) {
            setScrollContainer();
            $activity_container.html(store);
            incrementPageNumber();
            scrollToTop();

            // console.log('replace page');

        } else {
            $activity_container.append(store);
            incrementPageNumber();

            // console.log('append results');
        }
    }

    function incrementPageNumber() {
        var intPage = parseInt(current_page);
        var nextPage = intPage + 1;

        current_page = nextPage;
    }

    function handleEmptyResponse() {
        more_data = false;
        $scroll_container.off('scroll');
        $activity_container.append('<div class="panel-blank"></div>');
    }

    function setScrollContainer() {
        if ($activity_container.attr('data-scroll') == 'true') {
            $scroll_container = $activity_container;
        }

        if (more_data === false) {
            more_data = true;
        }

        $scroll_container.off('scroll');

        // Debounce waits until scrolling is done to fire callback.
        // This limits the amount of ajax calls
        $scroll_container.on('scroll', $.debounce(250, function(e) {
            infiniteScrollDiv();
        }));
    }

    function setSelectedEmail() {
        $(document).on('click', '.js-activity-container a.lead-email', function(e) {
            var selectedLeads = [{contact_id: $(this).data('lead-id')}];
            sessionStorage.setItem('selectedLeads', JSON.stringify(selectedLeads));
        });
    }

    function toggleAllCheckboxes() {
        $('.js-toggle-activity-checks').change(function(e) {
            if ($(this).is(':checked')) {
                $('.js-type-filter-check').prop('checked', true);
            } else {
                $('.js-type-filter-check').attr('checked', false);
            }
            current_page = 0;
            loadPage();
        });
    }

    function toggleCheckbox() {
        $(document).on('change', '.js-type-filter-check', function(e) {
            current_page = 0;
            loadPage();
        });
    }

    function handleSubmit() {
        $('.js-submit-filter').on('click', function() {
            current_page = 0;
            loadPage();
            loadUpdatedActivityCounts();
        });
    }

    function scrollToTop() {
        $scroll_container.animate({
            scrollTop : 0
        }, 150);
    }

    function init(container) {
        $activity_container = container;
        setSelectedEmail();
        setScrollContainer();
        toggleCheckbox();
        toggleAllCheckboxes();
        handleSubmit();
        loadPage();
    }

    return {
        init: init,
        loadPage: loadPage
    };

})();
